module.exports = __webpack_public_path__ + "5c66d0ef7d98992f0441a24e4bb1d98c.pdf";